import emptyStateMachines from '../../../../assets/empty-state-machines.svg';
import { memo } from 'react';
import { useCustomTranslation } from '../../../hooks';

const NotFoundPage = memo(() => {
  const { tWrapper } = useCustomTranslation('components.notFoundPage');

  return (
    <div className="flex h-full flex-col items-center justify-center gap-4">
      <div
        className="h-1/2 w-1/2 bg-contain bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${emptyStateMachines})` }}
      />
      <span className="text-s18-sb text-text-primary">{tWrapper('header')}</span>
      <span className="text-s18 text-text-primary">{tWrapper('instruction')}</span>
      <span className="text-s11-sb text-text-secondary uppercase">{tWrapper('errorCode')}</span>
    </div>
  );
});

NotFoundPage.displayName = 'NotFoundPage';

export default NotFoundPage;
